module.exports = __webpack_public_path__ + "static/img/battle_report_jjc.5ef80b9c.png";